import React from 'react';
import { INTEGRATIONS_COPY, QUERY } from '@sonar-software/sonar-ts-constants';
import { useAppNotifications, useOnMount } from '@hooks';
import { useLocation, useNavigate } from 'react-router-dom';

export const SalesforceReauthenticationNotification: React.FC = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { errorNotification, successNotification } = useAppNotifications();

	useOnMount(() => {
		const queryParams = new URLSearchParams(location.search);

		if (queryParams.has(QUERY.SALESFORCE_REAUTHENTICATION)) {
			const wasSuccessful = queryParams.get(QUERY.SALESFORCE_REAUTHENTICATION) === 'true';

			queryParams.delete(QUERY.SALESFORCE_REAUTHENTICATION);
			navigate({ search: queryParams.toString() }, { replace: true });

			if (wasSuccessful) {
				successNotification(INTEGRATIONS_COPY.SALESFORCE_ORG_REAUTH_SUCCESS);
			} else {
				errorNotification(INTEGRATIONS_COPY.SALESFORCE_ORG_REAUTH_FAILURE);
			}
		}
	});

	return null;
};
